<template>
	<vx-card :title='$t("Users")'>
		<vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="tableData">

			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

				<div class="flex flex-wrap-reverse items-center">
					<vs-button v-if="$checkPermission(402)" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addUserPrompt = true">{{$t("Add")}}</vs-button>
				</div>

				<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
					<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
						<span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ users.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : users.length }} of {{ users.length }}</span>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>

					<vs-dropdown-menu>

						<vs-dropdown-item @click="itemsPerPage=10">
							<span>10</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=20">
							<span>20</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=50">
							<span>50</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=100">
							<span>100</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>

			<template slot="thead">
				<vs-th sort-key="name">{{$t("Name")}}</vs-th>
				<vs-th sort-key="l_name">{{$t("LName")}}</vs-th>
				<vs-th v-if="userAbsenceRequests">{{$t("Requests")}}</vs-th>
				<vs-th sort-key="email">{{$t("Email")}}</vs-th>
				<vs-th sort-key="phone">{{$t("PhoneNumber")}}</vs-th>
                <vs-th sort-key="totp_enabled_text">{{$t("TOTPEnabled")}}</vs-th>
				<vs-th v-if="rolesLoaded" sort-key="role">{{$t("Role")}}</vs-th>
				<vs-th v-if="userTypesLoaded" sort-key="user_type">{{$t("UserType")}}</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
				<vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

					<vs-td :data="data[index].name">
						{{ data[index].name }}
					</vs-td>

					<vs-td :data="data[index].l_name">
						{{ data[index].l_name }}
					</vs-td>

					<vs-td v-if="userAbsenceRequests">
						<vs-chip color="warning" class="mr-6" v-if="userAbsenceRequests[data[index].id]">{{userAbsenceRequests[data[index].id]}}</vs-chip>
						<p v-else>0</p>
					</vs-td>

					<vs-td :data="data[index].email">
						{{ data[index].email }}
					</vs-td>

					<vs-td :data="data[index].phone">
						{{ data[index].phone }}
					</vs-td>

                    <vs-td :data="data[index].totp_enabled_text">
                        <vs-chip :color="(data[index].totp_enabled) ? 'success' : 'danger'">{{ data[index].totp_enabled_text }}</vs-chip>
                    </vs-td>

					<vs-td :data="data[index].role">
						{{ data[index].role }}
					</vs-td>

					<vs-td :data="data[index].userType">
						{{ data[index].userType }}
					</vs-td>

				</vs-tr>
				</tbody>
			</template>

		</vs-table>

		<vs-popup :title="$t('Add')" :active.sync="addUserPrompt">
			<div>
				<p class="mt-6">{{$t("Name")}}</p>
				<vs-input v-model="addName" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("LName")}}</p>
				<vs-input v-model="addLName" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("Email")}}</p>
				<vs-input v-model="addEmail" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("PhoneNumber")}}</p>
				<vs-input v-model="addPhone" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("RegistrationTerminalPIN")}}</p>
				<vs-input v-model="addPin" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("RegistrationTerminalRFIDId")}}</p>
				<vs-input v-model="addRFID" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("Role")}}</p>
				<vs-select autocomplete style="width: 100%" class="selectExample" v-model="addRole">
					<vs-select-item :key="index" :value="item" :text="item.name" v-for="(item,index) in this.roles" />
				</vs-select>
				<p class="mt-6">{{$t("UserType")}}</p>
				<vs-select autocomplete style="width: 100%" class="selectExample" v-model="addUserType">
					<vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.userTypes" />
				</vs-select>
				<vs-divider icon-pack="feather" icon="icon-lock" position="center" color="danger"></vs-divider>
				<permissions v-if="addRole.permissions !== undefined" ref="addPermissions" :permissions="[]" :disabled-permissions="addRole.permissions"></permissions>
				<vs-divider color="danger"/>
				<vs-button color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="addUser">{{$t("Add")}}</vs-button>
			</div>
		</vs-popup>

	</vx-card>
</template>
<script>

	import Permissions from "./Permissions";

	export default {
		components: {
			Permissions
		},
		data() {
			return {
				selected: {},
				users: [],

				itemsPerPage: 20,
				isMounted: false,

				addUserPrompt: false,

				addName: '',
				addLName: '',
				addEmail: '',
				addPhone: '',
				addUserType: '',
				addPin: '',
				addRFID: '',
				addRole: {},

				roles: {},
				rolesLoaded: false,
				userTypes: {},
				userTypesLoaded: false,

				userAbsenceRequests: undefined

			}
		},
		computed: {
			currentPage() {
				if(this.isMounted) {
					return this.$refs.table.currentx
				}
				return 0
			},
			tableData(){

				if(!this.rolesLoaded || !this.userTypesLoaded) return [];

				let data = [];
				for(let x = 0; x < this.users.length; x++){

					data.push({
						id: this.users[x].id,
						name: this.users[x].name,
						l_name: this.users[x].l_name,
						email: this.users[x].email,
						phone: this.users[x].phone,
                        totp_enabled: this.users[x].totp_enabled,
                        totp_enabled_text: (this.users[x].totp_enabled) ? this.$t('Yes') : this.$t('No'),
						role: this.roles[this.users[x].group].name,
						userType: this.userTypes[this.users[x].type].name,
					});

				}

				return data;

			}
		},
		methods: {
			handleSelected(tr) {
				if (!this.$checkPermission(401)) return;
				this.$router.push({ name: 'user', params: { id: tr.id } })
			},
			updateUsers() {
				const thisIns = this;
				this.$http.get('/api/v1/user/')
						.then(function (response) {
							thisIns.users = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});

				if(this.$checkPermission(401)){
					let thisIns = this;
					this.$http.get('/api/v1/user_absences/by_user')
							.then(function (response) {
								thisIns.userAbsenceRequests = response.data;
							});
				}
			},
			addUser() {
				const thisIns = this;
				this.$http.post('/api/v1/user/', {
					name: thisIns.addName,
					l_name: thisIns.addLName,
					email: thisIns.addEmail,
					phone: thisIns.addPhone,
					registration_terminal_pin: thisIns.addPin,
					rfid: thisIns.addRFID,
					group: thisIns.addRole.id,
					type: thisIns.addUserType,
					permissions: thisIns.$refs.addPermissions.permissionArrayNoDisabled
				}).then(function () {
					thisIns.updateUsers();
					thisIns.addUserPrompt = false;
					thisIns.addName = "" ;
					thisIns.addLName = "" ;
					thisIns.addEmail = "" ;
					thisIns.addPhone = "" ;
					thisIns.addPin = "";
					thisIns.addRFID = "";
					thisIns.addUserType = "" ;
					thisIns.addRole = {};
				}).catch(function (error) {
					thisIns.addUserPrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
		},
		beforeCreate(){

			const thisIns = this;
			this.$http.get('/api/v1/group/')
					.then(function (response) {
						for(let x = 0; x < response.data.length; x++){
							thisIns.roles[response.data[x].id] = response.data[x]
						}
						thisIns.rolesLoaded = true;
					});

			this.$http.get('/api/v1/user_type/')
					.then(function (response) {
						for(let x = 0; x < response.data.length; x++){
							thisIns.userTypes[response.data[x].id] = response.data[x]
						}
						thisIns.userTypesLoaded = true;
					});

		},
		created() {

			this.updateUsers();

		},
		mounted() {
			this.isMounted = true;
		},
		beforeRouteLeave (to, from, next) {
			if(this.addUserPrompt){
				this.addUserPrompt = false;
				next(false)
			}else{
				next()
			}
		}
	}
</script>
